import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  terms: [],
  isLoading: false,
  error: null,
};

const termsSlice = createSlice({
  name: "terms",
  initialState,
  reducers: {
    setTerms: (state, action) => {
      state.terms = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setTermsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setTermsError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearTerms: (state) => {
      state.terms = [];
      state.isLoading = false;
      state.error = null;
    },
  },
});

export const { setTerms, setTermsLoading, setTermsError, clearTerms } =
  termsSlice.actions;

export default termsSlice.reducer;
